import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { Thumbnail } from './Thumbnail';
import styles from './Thumbnails.css';
import { IImageInfo } from '../../types/newbuilding';

interface IThumbnailsProps {
  images: IImageInfo[];
}

export function Thumbnails({ images }: IThumbnailsProps) {
  const thumbnails = React.useMemo(() => {
    return images.slice(1, 4);
  }, [images]);

  if (images.length < 4) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      {thumbnails.map((thumbnail, i) => (
        <Thumbnail key={`thumbnail-${i}`} image={thumbnail}>
          {i === thumbnails.length - 1 && (
            <div className={styles['overlay']}>
              <UIText2 color="text-inverted-default">Ещё фото</UIText2>
            </div>
          )}
        </Thumbnail>
      ))}
    </div>
  );
}
